import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'
import apisaucePlugin from 'reactotron-apisauce'
import sagaPlugin from 'reactotron-redux-saga'

import Config from 'config'

Reactotron.configure({
    name: Config.projectName
})
    .use(apisaucePlugin())
    .use(reactotronRedux())
    .use(sagaPlugin())

if (Config.useReactotron) {
    Reactotron.connect()
}

console.tron = Reactotron



// WEBPACK FOOTER //
// src/config/reactotron.js